<template>
  <img
    class="object-cover"
    src="@/assets/images/navbar-icons/nav-home-icon.webp"
  >
</template>